import m from "../../geodata/es2015/fijiWestLow";
window.am4geodata_fijiWestLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/fijiWestLow.js
// module id = null
// module chunks = 